// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__2Ak_h","shortcutHint":"QuestionChoices_shortcutHint__1xXtD"};